import ContactListItem from './ContactListItem';

import { IContactList } from 'source/NFR.types';

const ContactList: React.FC<IContactList> = ({ contactGroups = [] }) => {
  return (
    <div className="contact-list">
      {contactGroups?.map(contactGroup => (
        <ContactListItem key={contactGroup.title} {...contactGroup} />
      ))}
    </div>
  );
};

ContactList.displayName = 'ContactList';

export default ContactList;
